import './FeaturesSection.scss';
import filterOptions from '../../../assets/images/home-page/filterOptions.svg';
import beaconShows from '../../../assets/images/home-page/beaconShows.svg';
import marketReady from '../../../assets/images/home-page/marketReady.svg';
import filterOptionsMobile from '../../../assets/images/home-page/filterOptions-mobile.svg';
import beaconShowsMobile from '../../../assets/images/home-page/beaconShows-mobile.svg';
import marketReadyMobile from '../../../assets/images/home-page/marketReady-mobile.svg';
import { useWindowSize } from '../../../hooks/useWindowSize';

export const FeaturesSection: React.FC = () => {
	const windowsSize = useWindowSize().width;
	const MOBILE_SCREEN = 600;
	const isMobile = windowsSize < MOBILE_SCREEN;
	return (
		<div className='features-section'>
			<div className='filteroptions-container'>
				<img
					src={isMobile ? filterOptionsMobile : filterOptions}
					className='feature-img'
					alt='Filter options'
				/>
			</div>
			<div className='beaconShows-container'>
				<img
					src={isMobile ? beaconShowsMobile : beaconShows}
					className='feature-img'
					alt='Filter options'
					decoding='async'
					loading='eager'
				/>
			</div>
			<div className='marketready-container'>
				<img
					src={isMobile ? marketReadyMobile : marketReady}
					className='feature-img'
					alt='Filter options'
					decoding='async'
					loading='eager'
				/>
			</div>
		</div>
	);
};
